module.exports = __webpack_public_path__ + "static/media/Johnharney.b4d14593.png";